import React, { useRef, useState, useEffect, createContext, useContext } from 'react';

// Contexte pour partager l'état du scroll horizontal, du drag et de la ligne survolée
const ScrollContext = createContext({ hasHorizontalScroll: false, hasMoved: false, hoveredRowId: null, setHoveredRowId: () => {} });

export const useScrollContext = () => useContext(ScrollContext);

/**
 * Wrapper pour permettre le drag horizontal avec la souris sur mobile/tablette
 * @param {React.ReactNode} children - Contenu de la table à wrapper
 * @param {string} className - Classes CSS additionnelles
 */
const ScrollableTableWrapper = ({ children, className = '' }) => {
  const scrollContainerRef = useRef(null);
  const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false);
  const [hasMoved] = useState(false);
  const [hoveredRowId, setHoveredRowId] = useState(null);

  // Détecter si le scroll horizontal est nécessaire
  useEffect(() => {
    const checkScroll = () => {
    const container = scrollContainerRef.current;
      if (container) {
        const hasScroll = container.scrollWidth > container.clientWidth;
        setHasHorizontalScroll(hasScroll);
      }
    };

    checkScroll();
    window.addEventListener('resize', checkScroll);
    
    // Observer les changements de taille du contenu
    const resizeObserver = new ResizeObserver(checkScroll);
    if (scrollContainerRef.current) {
      resizeObserver.observe(scrollContainerRef.current);
    }

    return () => {
      window.removeEventListener('resize', checkScroll);
      resizeObserver.disconnect();
    };
  }, [children]);

  return (
    <ScrollContext.Provider value={{ hasHorizontalScroll, hasMoved, hoveredRowId, setHoveredRowId }}>
    <div
      ref={scrollContainerRef}
      className={`overflow-auto h-full w-full thin-scrollbar ${className}`}
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {children}
    </div>
    </ScrollContext.Provider>
  );
};

export default ScrollableTableWrapper;
